import { render, staticRenderFns } from "./VTab.vue?vue&type=template&id=6470d273&scoped=true&"
import script from "./VTab.vue?vue&type=script&lang=js&"
export * from "./VTab.vue?vue&type=script&lang=js&"
import style0 from "./VTab.vue?vue&type=style&index=0&id=6470d273&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6470d273",
  null
  
)

export default component.exports